import {Routes, Route} from "react-router-dom";

// pages 
import Evaluation from "../../pages/dashboard/evaluation/Evaluation";
import Questionnaire from "../../pages/dashboard/evaluation/questionnaire/Questionnaire";
import Breakdown from "../../pages/dashboard/evaluation/breakdown/Breakdown";

const EvaluationRoutes = () =>{
    return(
        <Routes>
            <Route path="/" element={<Evaluation/>} />
            <Route path="/questionnaire/:id" element={<Questionnaire/>}/>
            <Route path="/breakdown/:id" element={<Breakdown/>}/>
        </Routes>
    )
}

export default EvaluationRoutes